var _path, _g, _path2, _g2, _path3, _path4, _path5, _path6, _g3, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 92,
    viewBox: "0 0 130 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2065_1555)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2065_1555",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 1,
    width: 27,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02588 1.90332H33.6358V48.0045H7.02588V1.90332Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2065_1555)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12838 31.4173L16.1007 30.192L16.1961 32.6002C16.242 33.8219 16.4574 36.4879 17.3295 37.4554C18.0075 38.2075 18.9256 38.4123 19.9037 38.4123C20.6911 38.4123 21.4679 38.271 22.1424 37.8438C22.6649 37.5119 23.0216 37.0987 23.2228 36.5126C23.6183 35.372 23.6466 33.4512 23.6466 32.2506V2.66406H33.2581V31.954C33.2581 34.7471 33.0109 37.9885 31.8739 40.5697C30.8781 42.8296 29.275 44.5916 27.114 45.7815C24.9001 46.9997 22.4425 47.487 19.9319 47.487C16.3055 47.487 12.8487 46.5054 10.331 43.7724C7.73219 40.9511 7.02245 37.014 7.09307 33.2923L7.12838 31.4173Z",
    fill: "#6A3F13"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2065_1555",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 2,
    width: 36,
    height: 45
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7769 2.61523H123.19V46.9191H88.7769V2.61523Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2065_1555)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.911 23.0532C119.01 23.7665 119.991 24.6528 120.814 25.7368C122.452 27.8908 123.201 30.3943 123.201 33.092C123.201 35.2459 122.745 37.3186 121.796 39.2536C120.945 40.9909 119.794 42.5693 118.24 43.7416C116.729 44.8821 114.952 45.6095 113.13 46.0756C110.895 46.6476 108.487 46.8101 106.188 46.8101H88.8828V2.66504H105.948C108.65 2.66504 111.609 2.95812 114.105 4.04921C116.333 5.02377 118.113 6.55624 119.391 8.62543C120.602 10.5781 121.28 12.725 121.28 15.0272C121.28 17.1599 120.683 19.155 119.575 20.9699C119.101 21.7432 118.54 22.4353 117.911 23.0532ZM98.5014 19.3774H104.896C106.135 19.3774 108.081 19.3633 109.275 19.0067C109.988 18.7913 110.701 18.4452 111.15 17.8308C111.609 17.1988 111.743 16.4149 111.743 15.6487C111.743 14.8295 111.58 14.035 111.139 13.3358C110.772 12.7532 110.277 12.4001 109.621 12.1918C108.212 11.7433 105.715 11.7363 104.243 11.7363H98.5014V19.3774ZM98.5014 37.7388H106.188C107.149 37.7388 108.434 37.7565 109.377 37.587C110.157 37.4457 110.966 37.2092 111.644 36.7854C112.181 36.4535 112.576 35.9592 112.876 35.4048C113.261 34.6915 113.399 33.8971 113.399 33.092C113.399 32.1421 113.19 31.2558 112.65 30.4684C112.142 29.734 111.457 29.2749 110.609 28.9995C109.123 28.5122 107.039 28.4487 105.489 28.4487H98.5014V37.7388Z",
    fill: "#6A3F13"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6412 45.7189C75.0092 44.6878 73.6674 44.3665 72.6398 44.9986C71.6123 45.6306 71.291 46.9795 71.923 48.0105L76.9512 56.2167C77.5833 57.2442 78.9286 57.5691 79.9561 56.9335C80.9801 56.3014 81.3015 54.9526 80.6729 53.925L75.6412 45.7189Z",
    fill: "#90A4AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3299 7.00977C72.0819 7.00977 80.8 15.7526 80.8 26.5364C80.8 37.3202 72.0819 46.063 61.3299 46.063C50.5743 46.063 41.8562 37.3202 41.8562 26.5364C41.8562 15.7526 50.5743 7.00977 61.3299 7.00977Z",
    fill: "#80DEEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5119 5.63526C54.0592 2.21369 60.6763 1.15438 67.0075 2.66919C73.2998 4.17694 78.614 8.14936 82.1133 13.5801C82.2157 13.746 82.1521 13.6366 82.2545 13.8131C85.496 19.3957 86.6365 25.9352 85.1358 32.2416C83.6351 38.5516 79.6733 43.8799 74.2567 47.3862C74.0907 47.4957 74.1967 47.4286 74.0236 47.531C68.4587 50.7796 61.9369 51.9236 55.6481 50.4194C49.3594 48.9152 44.0487 44.9357 40.5459 39.512C40.4364 39.3425 40.5035 39.452 40.4047 39.279C37.1596 33.6964 36.0191 27.1534 37.5198 20.8505C39.0311 14.4982 42.9647 9.0533 48.5119 5.63526ZM65.0089 11.0907C60.9059 10.1091 56.6262 10.7906 53.0316 13.0081C49.437 15.222 46.8947 18.7389 45.9166 22.8526C44.942 26.9557 45.6165 31.2353 47.8092 34.8334L47.834 34.8722C50.0303 38.481 53.5472 41.0198 57.6467 42.0014C61.7392 42.9795 66.0047 42.2945 69.5957 40.1017L69.6346 40.077C73.2362 37.8771 75.7609 34.3461 76.739 30.2395C77.7171 26.1329 77.025 21.8568 74.8428 18.2517L74.8217 18.2128C72.6324 14.597 69.1049 12.0688 65.0089 11.0907Z",
    fill: "#FFFBF4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2065_1555",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 50,
    width: 24,
    height: 30
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8228 50.9492H96.3755V79.4588H73.8228V50.9492Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2065_1555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9952 54.8547L80.3977 51.5249C81.4252 50.8929 82.7705 51.2142 83.3991 52.2453C83.4097 52.2629 83.4202 52.2806 83.4308 52.2982L95.9731 72.7606C96.6051 73.7916 96.2838 75.1405 95.2563 75.7726C95.2386 75.7832 95.221 75.7937 95.2033 75.8043L89.8008 79.1341L88.6568 77.2697L89.8008 79.1376C88.7733 79.7697 87.4315 79.4484 86.7994 78.4173C86.7889 78.3997 86.7783 78.382 86.7677 78.3643L74.2254 57.8985L76.0828 56.7544L74.2219 57.8985C73.5934 56.8709 73.9147 55.5185 74.9387 54.8865C74.9599 54.8759 74.974 54.8653 74.9952 54.8547Z",
    fill: "#5D4037"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9323 55.512C72.9048 56.144 72.5835 57.4929 73.2155 58.5204C73.844 59.5515 75.1894 59.8728 76.2169 59.2408L83.6921 54.6328C84.7196 54.0007 85.0374 52.6519 84.4089 51.6208C83.7768 50.5933 82.4315 50.2719 81.4075 50.904L73.9323 55.512Z",
    fill: "#6D4C41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.923 24.9621C46.8595 25.4706 47.2197 25.9332 47.7246 25.9967C48.2295 26.0603 48.6921 25.7037 48.7557 25.1952C49.1723 21.9255 50.7683 19.0618 53.0882 17.0138C55.4011 14.9693 58.4378 13.744 61.7287 13.744C62.0394 13.744 62.336 13.7511 62.6185 13.7723C62.9222 13.7935 63.2188 13.8217 63.5048 13.8606C64.0097 13.9277 64.4758 13.5746 64.5429 13.0661C64.61 12.5611 64.2569 12.095 63.752 12.0244C63.4059 11.9785 63.0705 11.9432 62.7421 11.922C62.389 11.8973 62.05 11.8867 61.7287 11.8867C57.9717 11.8867 54.5077 13.285 51.863 15.619C49.2217 17.953 47.3997 21.2228 46.923 24.9621Z",
    fill: "#ECEFF1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2065_1555",
    x: -0.267475,
    y: -0.357011,
    width: 131.535,
    height: 92.2137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.42804
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.39253
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.976471 0 0 0 0 0.870588 0 0 0 0 0.694118 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2065_1555"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2065_1555",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsIcon);
export default __webpack_public_path__ + "static/media/jobs_icon.ac48c53abdf60b41a0bdb428518239e0.svg";
export { ForwardRef as ReactComponent };